import { SearchIntailSection } from "./styles";

const SearchIntialRender = () => {
  return <SearchIntailSection></SearchIntailSection>;
};

export default SearchIntialRender;
